import { BrandContext } from "@/contexts/BrandContext/context";
import { useDriver } from "@/contexts/driver";
import { useContext, useEffect } from "react";
import OnboardingFloatingMenu from "@/pages/brand/onboarding/OnboardingFloatingMenu";

export const defaultTourConfig = {
  showProgress: true,
  allowClose: true,
  overlayOpacity: 0.3,
  allowKeyboardControl: true,
  popoverOffset: 30,
};

export function BrandOnboarding() {
  const { isLoading, brandDetails } = useContext(BrandContext);
  const { setIsTourOpen, isTourOpen } = useDriver();

  // Set initial tour state
  useEffect(() => {
    if (!isLoading && brandDetails) {
      setIsTourOpen(true);
    }
  }, [isLoading, brandDetails, setIsTourOpen]);

  return <OnboardingFloatingMenu isVisible={isTourOpen} />;
}
